import ProjectInfoCardPresenter from "./ProjectInfoCardPresenter";

export const ProjectInfoCard = ProjectInfoCardPresenter;

export default ProjectInfoCard;
